import { render, staticRenderFns } from "./CorrelationCreateFormula.vue?vue&type=template&id=0194e8e2"
import script from "./CorrelationCreateFormula.vue?vue&type=script&lang=js"
export * from "./CorrelationCreateFormula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports